// src/lib/BackoffStrategy.ts
var BackoffStrategy = class {
	randomisationFactor_;
	initialDelay_;
	maxDelay_;
	constructor(options = {}) {
		if (typeof options.initialDelay === "number" && options.initialDelay < 1) throw new Error("The initial timeout must be greater than 0.");
		else if (typeof options.maxDelay === "number" && options.maxDelay < 1) throw new Error("The maximal timeout must be greater than 0.");
		this.initialDelay_ = options.initialDelay ?? 100;
		this.maxDelay_ = options.maxDelay ?? 1e4;
		if (this.maxDelay_ <= this.initialDelay_) throw new Error("The maximal backoff delay must be greater than the initial backoff delay.");
		if (typeof options.randomisationFactor === "number" && (options.randomisationFactor < 0 || options.randomisationFactor > 1)) throw new Error("The randomisation factor must be between 0 and 1.");
		this.randomisationFactor_ = options.randomisationFactor || 0;
	}
	getMaxDelay() {
		return this.maxDelay_;
	}
	getInitialDelay() {
		return this.initialDelay_;
	}
	/**
	* Computes and returns the next backoff delay.
	*/
	next() {
		const backoffDelay = this.next_();
		const randomisationMultiple = 1 + Math.random() * this.randomisationFactor_;
		return Math.round(backoffDelay * randomisationMultiple);
	}
	/**
	* Resets the backoff delay to its initial value.
	*/
	reset() {
		this.reset_();
	}
};
export { BackoffStrategy as default };

//# sourceMappingURL=BackoffStrategy.js.map